var dynamicRequire = require('../dynamicRequire');
var React = dynamicRequire('react');
var ColorPicker = require('./ColorPicker.jsx');
var Dimensions = require('./Dimensions.jsx');
var Options = require('./Options.jsx');
var Mssg = dynamicRequire('Mssg.jsx');

class Choices extends React.Component {

    render() {
        var link = this.props.location.search ? this.props.location.href + '&refresh' : '?refresh';
        return <div className="lr-sidebar-box lr-casefactory-choices choices sidebar-box">
            <Dimensions {...this.props} />
            <ColorPicker {...this.props} />
            <Options {...this.props} />

            <div className="lr-casefactory-choices-reset-button reset-button">
                <a href={link}><Mssg __key="nc_casefactory.reset.all.values" /></a>
            </div>
        </div>
    }
}

Choices.contextTypes = {
    emitter: React.PropTypes.object.isRequired
};

module.exports = Choices;



// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Choices.jsx